import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { CandidateCreateRequest } from '../../types/candidate/CandidateCreateRequest'
import candidateService, {candidateHooks} from '../../api/candidate.api'
import ResultModalContent from '../modals/ResultModalContent'
import { ROUTES } from '../../helpers/routeConsts'
import ResultModal from '../modals/ResultModal'
import ReactInputMask from 'react-input-mask'
import {useLocation, useParams} from "react-router-dom";
import {getErrorMessage} from "../../helpers/errorMessage";
import {useStores} from "../../stores";

type Props = {}

const CandidateCreateForm = (props: Props) => {

    const [formValues, setFormValues] = useState<CandidateCreateRequest>(new CandidateCreateRequest())
    //--
    const [showResult, setShowResult] = useState<boolean>(false)
    const [resultModalContent, setResultModalContent] = useState<React.ReactNode>(<></>)
    const [link, setLink] = useState<string | null>(null)

    const {data: categories} = candidateHooks.useCandidateCategories()
    const getListCategories = () => {
        if (!categories || !categories[0]) return []
        return categories[0]
    }
    const listCategories = getListCategories()

    const handleCloseResult = () => {
        setShowResult(false)
    }

    const handleShowResult = () => {
        setShowResult(true)
    }
    //
    const location = useLocation();
    const { authStore } = useStores()
    const path = location.state?.path;
    const handleForm = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        candidateService.create({...formValues, vacancyCompany: authStore.user?.vacancyCompany || null}).then((response) => {
            if (response.status === 200) {
                setResultModalContent(<ResultModalContent type="success" message={"Кандидат успешно создан"} />)
                setLink(path || ROUTES.CANDIDATE + "/open")
                handleShowResult()
            }
        }).catch((e: any) => {
            setResultModalContent(<ResultModalContent type="error" message={getErrorMessage(e)} />)
            handleShowResult()
        })
    }


    return <>
        <ResultModal
            show={showResult}
            link={link}
            title={"Кандидат создан"}
            handleClose={handleCloseResult}
            children={resultModalContent}
        />
        <form onSubmit={(e) => handleForm(e)} className="white-form-block mt-4 pt-4">
            <div className="form-group mb-5 d-flex">
                <label><span className="text-danger h5">*</span> Имя</label>
                <input
                    className="form-control"
                    value={formValues.firstName}
                    required={true}
                    onChange={(e) => { setFormValues((prev) => ({ ...prev, firstName: e.target.value })) }}
                />
            </div>
            <div className="form-group mb-5 d-flex">
                <label><span className="text-danger h5">*</span> Фамилия</label>
                <input
                    className="form-control"
                    value={formValues.lastName}
                    required={true}
                    onChange={(e) => { setFormValues((prev) => ({ ...prev, lastName: e.target.value })) }}
                />
            </div>
            <div className="form-group mb-5 d-flex">
                <label>Почта</label>
                <input
                    className="form-control"
                    value={formValues.email}
                    type='email'
                    onChange={(e) => { setFormValues((prev) => ({ ...prev, email: e.target.value })) }}
                />
            </div>
            <div className="form-group mb-5 d-flex">
                <label>Телефон</label>
                <Form.Control
                    className="form-control"
                    value={formValues.phone}
                    as={ReactInputMask} mask="+7 (999) 999-99-99"
                    onChange={(e) => { setFormValues((prev) => ({ ...prev, phone: e.target.value })) }}
                />
            </div>
            <div className="form-group mb-5 d-flex">
                <label>Категория</label>
                <Form.Control
                  as="select"
                  value={formValues.categoryId || ""}
                  onChange={(e) => {
                      setFormValues((prev) => ({...prev, categoryId: e.target.value}))
                  }}
                >
                    <option value="">Выберите категорию</option>
                    {listCategories?.map((category: any) => (
                      <option key={category.id} value={category.id}>
                          {category.name} ({category.code})
                      </option>
                    ))}
                </Form.Control>
            </div>
            <div className="d-flex mb-5">
                <label htmlFor=""></label>
                <Button type="submit" size={'lg'}>Создать кандидата</Button>
            </div>
        </form>
    </>
}

export default CandidateCreateForm